export default "__VITE_ASSET__C$OkVYbw__"